import React, { useState } from "react";
import ModalSkeleton from "./ModalSkeleton";
import { Row, Col, Modal, Button } from "react-bootstrap";
import "../assets/styles/addContractDetailsModal.css";
import moment from 'moment'

function AddContractDetailsModal({
  open,
  setOpen,
  date,
  setDate,
  month,
  setMonth,
  year,
  setYear,
  companyName,
  setCompanyName,
  employeeName,
  setEmployeeName,
  city,
  setCity,
  cityState,
  setCityState,
  cityDistrict,
  setCityDistrict,
  jobTitle,
  setJobTitle,
  wage,
  setWage,
  wageRate,
  setWageRate,
  performanceReviewBasis,
  setPerformanceReviewBasis,
  benefits,
  setBenefits,
  probationtimeFrame,
  setProbationTimeFrame,
  timeForVacation,
  setTimeForVacation,
  timeForSickOrPersonal,
  setTimeForSickOrPersonal,
  terminationTimeLength,
  setTerminationTimeLength,
  solicitBusinessTimeFrame,
  setSolicitBusinessTimeFrame,
  countryName,
  setCountryName,
  province,
  setProvince,
  territory,
  setTerritory,
  setAllFieldsCompleted,
  meetingDate,
  setMeetingDate,
  meetingTime,
  setMeetingTime,
  meetingAdrress,
  setMeetingAddress,
  extraComment,
  setExtraComment,
}) {

  console.log(setExtraComment);
  return (
    <ModalSkeleton
      open={open}
      setOpen={setOpen}
      title={"Fill Contract"}
      size={"lg"}
    >
      <div className="add-contract-details-modal">
        <Row>
          <Col md={6}>
            <div className="label-and-input">
              <label>Date</label>
              <input
                type={"date"}
                placeholder=""
                value={date}
                onChange={(e) => setDate(e.target.value)}
                min={moment().format("YYYY-MM-DD")}
              />
            </div>
          </Col>
          <Col md={6}>
            <div className="label-and-input">
              <label>Month</label>
              <input
                type={"month"}
                placeholder=""
                value={month}
                onChange={(e) => setMonth(e.target.value)}
              />
            </div>
          </Col>
          <Col md={6}>
            <div className="label-and-input">
              <label>Year</label>
              <input
                type={"text"}
                placeholder="Enter year"
                value={year}
                onChange={(e) => setYear(e.target.value)}
              />
            </div>
          </Col>
          <Col md={6}>
            <div className="label-and-input">
              <label>Company Name</label>
              <input
                type={"text"}
                placeholder="Enter Company name"
                value={companyName}
                onChange={(e) => setCompanyName(e.target.value)}
              />
            </div>
          </Col>
          <Col md={6}>
            <div className="label-and-input">
              <label>Employ Name</label>
              <input
                type={"text"}
                placeholder="Enter employee name"
                value={employeeName}
                onChange={(e) => setEmployeeName(e.target.value)}
              />
            </div>
          </Col>
          <Col md={6}>
            <div className="label-and-input">
              <label>City</label>
              <input
                type={"text"}
                placeholder="Enter  city"
                value={city}
                onChange={(e) => setCity(e.target.value)}
              />
            </div>
          </Col>
          <Col md={6}>
            <div className="label-and-input">
              <label>State</label>
              <input
                type={"text"}
                placeholder="Enter state"
                value={cityState}
                onChange={(e) => setCityState(e.target.value)}
              />
            </div>
          </Col>
          <Col md={6}>
            <div className="label-and-input">
              <label>District</label>
              <input
                type={"text"}
                placeholder="Enter district"
                value={cityDistrict}
                onChange={(e) => setCityDistrict(e.target.value)}
              />
            </div>
          </Col>
          <Col md={6}>
            <div className="label-and-input">
              <label>Job Title</label>
              <input
                type={"text"}
                placeholder="Enter job title"
                value={jobTitle}
                onChange={(e) => setJobTitle(e.target.value)}
              />
            </div>
          </Col>
          <Col md={6}>
            <div className="label-and-input">
              <label>Wage</label>
              <input
                type={"text"}
                placeholder="Enter wage"
                value={wage}
                onChange={(e) => setWage(e.target.value)}
              />
            </div>
          </Col>
          <Col md={6}>
            <div className="label-and-input">
              <label>Wage Rate</label>
              <input
                type={"text"}
                placeholder="Enter wage rate"
                value={wageRate}
                onChange={(e) => setWageRate(e.target.value)}
              />
            </div>
          </Col>
          <Col md={6}>
            <div className="label-and-input">
              <label>Performance Basis</label>
              <input
                type={"text"}
                placeholder="Enter performance review basis"
                value={performanceReviewBasis}
                onChange={(e) => setPerformanceReviewBasis(e.target.value)}
              />
            </div>
          </Col>
          <Col md={6}>
            <div className="label-and-input">
              <label>Probation Time Frame</label>
              <input
                type={"text"}
                placeholder="Enter probation time frame"
                value={probationtimeFrame}
                onChange={(e) => setProbationTimeFrame(e.target.value)}
              />
            </div>
          </Col>
          <Col md={6}>
            <div className="label-and-input">
              <label>Vacation Time</label>
              <input
                type={"text"}
                placeholder="Enter vacation time"
                value={timeForVacation}
                onChange={(e) => setTimeForVacation(e.target.value)}
              />
            </div>
          </Col>
          <Col md={6}>
            <div className="label-and-input">
              <label>Time For Sick Or Personal</label>
              <input
                type={"text"}
                placeholder="Enter time for sick or personal"
                value={timeForSickOrPersonal}
                onChange={(e) => setTimeForSickOrPersonal(e.target.value)}
              />
            </div>
          </Col>
          <Col md={6}>
            <div className="label-and-input">
              <label>Termination Time Length</label>
              <input
                type={"text"}
                placeholder="Enter termination time length"
                value={terminationTimeLength}
                onChange={(e) => setTerminationTimeLength(e.target.value)}
              />
            </div>
          </Col>
          <Col md={6}>
            <div className="label-and-input">
              <label>Solict Business Time Frame</label>
              <input
                type={"text"}
                placeholder="Enter solict time frame"
                value={solicitBusinessTimeFrame}
                onChange={(e) => setSolicitBusinessTimeFrame(e.target.value)}
              />
            </div>
          </Col>
          <Col md={6}>
            <div className="label-and-input">
              <label>Country</label>
              <input
                type={"text"}
                placeholder="Enter country"
                value={countryName}
                onChange={(e) => setCountryName(e.target.value)}
              />
            </div>
          </Col>
          <Col md={6}>
            <div className="label-and-input">
              <label>Province</label>
              <input
                type={"text"}
                placeholder="Enter province"
                value={province}
                onChange={(e) => setProvince(e.target.value)}
              />
            </div>
          </Col>
          <Col md={6}>
            <div className="label-and-input">
              <label>Territory</label>
              <input
                type={"text"}
                placeholder="Enter territory"
                value={territory}
                onChange={(e) => setTerritory(e.target.value)}
              />
            </div>
          </Col>
          <Col md={6}>
            <div className="label-and-input">
              <label>Benefits</label>
              <input
                type={"text"}
                placeholder="Enter benefits"
                value={benefits}
                onChange={(e) => setBenefits(e.target.value)}
              />
            </div>
          </Col>
          <Col md={6}>
            <div className="label-and-input">
              <label>Meeting Time</label>
              <input
                type={"time"}
                placeholder="Enter Meeting Time"
                value={meetingTime}
                onChange={(e) => setMeetingTime(e.target.value)}
              />
            </div>
          </Col>
          <Col md={6}>
            <div className="label-and-input">
              <label>Meeting Date</label>
              <input
                type={"date"}
                placeholder="Enter Meeting Date"
                value={meetingDate}
                onChange={(e) => setMeetingDate(e.target.value)}
                min={moment().format("YYYY-MM-DD")}
              />
            </div>
          </Col>
          <Col md={6}>
            <div className="label-and-input">
              <label>Meeting Address</label>
              <input
                type={"text"}
                placeholder="Enter Meeting Address"
                value={meetingAdrress}
                onChange={(e) => setMeetingAddress(e.target.value)}
              />
            </div>
          </Col>
          <Col md={12}>
            <div className="label-and-input">
              <label>Extra Comment</label>
              <textarea
                placeholder="Enter Extra Comment"
                value={extraComment}
                onChange={(e) => setExtraComment(e.target.value)}
              />
            </div>
          </Col>
        </Row>
      </div>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => setOpen(false)}>
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={() => {
            setAllFieldsCompleted(true);
            setOpen(false);
          }}
        >
          Set
        </Button>
      </Modal.Footer>
    </ModalSkeleton>
  );
}

export default AddContractDetailsModal;
